module.exports = __webpack_public_path__ + "media/images/athletes/2425-67f2c3baa8e21c925ff164bc4e89d48c.png";